import { PrintObject } from "@/models/PrintObject";
import { CategoryModel } from "@/models/CategoryModel";

export class PrintGroup {
  parent: CategoryModel;
  collapsed: boolean;
  topics: PrintObject[];

  constructor(parent: CategoryModel, topics: PrintObject[]) {
    this.parent = parent;
    this.topics = topics;
    this.collapsed = true;
  }
}
